import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { timeLeft } from './time-left.js';

/**
 * *"Cierra en 2 d 3 h 15 min"*, or *"Plazo de pujas terminado"*. `now` is the loader's, so this
 * renders the same on the server and the client — and the server decides anyway.
 */
export function Countdown({ closesAt, now }: { closesAt: string; now: string }): ReactElement {
  const { t } = useTranslation();
  const left = timeLeft(closesAt, now);
  return (
    <p className="mp-meta" data-testid="auction-countdown">
      {left === null ? t('auction.closed') : t('auction.closesIn', { ...left })}
    </p>
  );
}
